import classNames from 'classnames';

type Props = {
  as?: 'div' | 'button';
  className?: string;
  color?: string;
  text?: string;
  active?: boolean;
  disableHover?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

export const ColorDot: React.FC<Props> = ({
  as = 'button',
  className,
  color,
  active,
  text,
  disableHover = false,
  onClick,
}) => {
  const Component = as;

  const backgroundStyle = color ? { background: color } : {};

  const multiColorSvg = (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      style={{ position: 'absolute', top: 0, left: 0, borderRadius: '50%' }}
    >
      <g>
        <path d="M 15 15 L 15 0 A 15 15 0 0 1 28.45 7.5 Z" fill="#d71313" />
        <path d="M 15 15 L 28.45 7.5 A 15 15 0 0 1 28.45 22.5 Z" fill="#f18b00" />
        <path d="M 15 15 L 28.45 22.5 A 15 15 0 0 1 15 30 Z" fill="#dddb00" />
        <path d="M 15 15 L 15 30 A 15 15 0 0 1 1.55 22.5 Z" fill="#418741" />
        <path d="M 15 15 L 1.55 22.5 A 15 15 0 0 1 1.55 7.5 Z" fill="#485ff0" />
        <path d="M 15 15 L 1.55 7.5 A 15 15 0 0 1 15 0 Z" fill="#c90de6" />
      </g>
    </svg>
  );

  return (
    <Component
      className={classNames(
        'relative ms-[5px] grid h-[30px] w-[30px] items-center justify-center overflow-hidden rounded-full text-[12px] ring-1 ring-neutrals-black-50 ring-offset-0',
        { 'ring-offset-4': active },
        { 'hover:ring-offset-4': !disableHover },
        className,
      )}
      style={backgroundStyle}
      onClick={onClick}
    >
      {!color && multiColorSvg}
      <span className="relative z-10">{text}</span>
    </Component>
  );
};
